import { useRef, useState } from 'react';
import { useGlobeSection } from '../stage/Stage';
import { range } from '../motion/tokens';
import { useLocale } from '../i18n/locale';
import { sectionId } from '../content/site';
import { HOME } from './content';
import { Lines } from './Lines';

/** Back to the globe: origin (China, the United States or another market) → transit → Colombia → destination. */
export function Journey() {
  const { locale } = useLocale(); const copy = HOME[locale].journey;
  const ref = useRef<HTMLElement>(null);
  const bar = useRef<HTMLSpanElement>(null);
  const [leg, setLeg] = useState(0);
  useGlobeSection(ref, 'journey', ({ track }, stage) => {
    const progress = range(track, 0.04, 0.94);
    stage.globe.setJourney(progress);
    const next = Math.min(copy.legs.length - 1, Math.floor(progress * copy.legs.length * 0.999));
    setLeg(previous => (previous === next ? previous : next));
    if (bar.current) bar.current.style.transform = `scaleX(${progress.toFixed(4)})`;
  });
  return (
    <section ref={ref} id={sectionId('journey', locale)} className="journey" data-tone="dark" aria-labelledby="journey-title">
      <div className="journey__sticky">
        <div className="journey__inner wrap">
          <h2 id="journey-title" className="journey__title"><Lines lines={copy.title} /></h2>
          <div className="journey__panel">
            <ol className="journey__legs">
              {copy.legs.map((item, index) => (
                <li key={item.place} className={index === leg ? 'is-current' : index < leg ? 'is-past' : undefined} aria-current={index === leg ? 'step' : undefined}>
                  <span className="journey__place">{item.place}</span>
                  <span className="journey__leg-title">{item.title}</span>
                </li>
              ))}
            </ol>
            <span className="journey__track" aria-hidden="true"><span ref={bar} className="journey__progress" /></span>
          </div>
        </div>
      </div>
    </section>
  );
}
